(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["our-story-chapters"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-craft"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(!window.__spReveal){window.__spReveal=1;var run=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?run():document.addEventListener('DOMContentLoaded',run);}
  document.querySelectorAll('[data-sp-video]').forEach(function(v){var s=parseFloat(v.dataset.s)||0,e=parseFloat(v.dataset.e)||0;v.addEventListener('loadedmetadata',function(){if(s)v.currentTime=s;});v.addEventListener('timeupdate',function(){if(e&&(v.currentTime>=e||v.currentTime<s))v.currentTime=s;});v.addEventListener('ended',function(){v.currentTime=s;v.play().catch(function(){});});if('IntersectionObserver' in window){var vio=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){v.play().catch(function(){});}else{v.pause();}});},{threshold:.1});vio.observe(v);}else{v.play().catch(function(){});}});
  // Size the hero to fill from its own top edge to the viewport bottom, so a theme header sitting
  // above it never pushes the bottom-aligned content off-screen (fixes clipped CTA / content too low).
  var fit=function(){document.querySelectorAll('[data-sp-hero]').forEach(function(h){var top=h.getBoundingClientRect().top+(window.pageYOffset||document.documentElement.scrollTop||0);h.style.minHeight=Math.max(560,window.innerHeight-top)+'px';});};
  fit();window.addEventListener('resize',fit);window.addEventListener('load',fit);
  // "Read our story" (and any empty-link CTA) smooth-scrolls to the next section instead of jumping to top.
  document.querySelectorAll('[data-sp-scroll-next]').forEach(function(a){a.addEventListener('click',function(ev){var href=a.getAttribute('href')||'';if(href===''||href==='#'){ev.preventDefault();var sec=a.closest('section'),n=sec?sec.nextElementSibling:null;while(n&&n.tagName!=='SECTION'){n=n.nextElementSibling;}if(n){n.scrollIntoView({behavior:'smooth',block:'start'});}else{window.scrollTo({top:window.innerHeight,behavior:'smooth'});}}});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-made-in-uk"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-products"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-stats"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-testimonial"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-timeline"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}
document.querySelectorAll('[data-sp-timeline]').forEach(function(tl){
  var section=tl.closest('section'),rail=tl.querySelector('[data-sp-rail]'),cards=Array.prototype.slice.call(tl.querySelectorAll('[data-sp-card]'));
  var prev=section.querySelector('[data-sp-prev]'),next=section.querySelector('[data-sp-next]'),current=section.querySelector('[data-sp-current]'),progress=section.querySelector('[data-sp-progress]'),scrub=section.querySelector('[data-sp-scrub]');
  var eras=Array.prototype.slice.call(section.querySelectorAll('[data-sp-era]'));
  if(!rail||!cards.length)return;
  var index=0,ticking=false,dragging=false,startX=0,startScroll=0,reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var years=cards.map(function(card){return parseInt(card.getAttribute('data-year'),10)||0});
  var firstYear=years[0],lastYear=years[years.length-1],yearSpan=Math.max(1,lastYear-firstYear);
  function maxScroll(){return Math.max(0,rail.scrollWidth-rail.clientWidth)}
  function activeIndex(){
    var best=0,distance=Infinity;
    cards.forEach(function(card,i){var d=Math.abs((card.offsetLeft-2)-rail.scrollLeft);if(d<distance){distance=d;best=i}});
    return best;
  }
  function update(){
    var max=maxScroll(),atStart=rail.scrollLeft<=2,atEnd=max-rail.scrollLeft<=2;
    index=atEnd?cards.length-1:Math.max(0,Math.min(cards.length-1,activeIndex()));
    var activeYear=years[index]||firstYear,yearRatio=Math.floor(((activeYear-firstYear)*100)/yearSpan)/100;
    cards.forEach(function(card,i){card.classList.toggle('is-active',i===index);if(i===index){card.setAttribute('aria-current','true')}else{card.removeAttribute('aria-current')}});
    if(current)current.textContent=String(index+1).padStart(2,'0');
    if(progress)progress.style.transform='scaleX('+Math.max(0,Math.min(1,yearRatio))+')';
    if(scrub)scrub.setAttribute('aria-valuenow',String(activeYear));
    var currentEra=null;
    eras.forEach(function(btn){var target=parseInt(btn.getAttribute('data-sp-era'),10);if(target<=index)currentEra=btn;btn.classList.remove('is-current');btn.setAttribute('aria-pressed','false')});
    if(currentEra){currentEra.classList.add('is-current');currentEra.setAttribute('aria-pressed','true')}
    if(prev)prev.disabled=atStart;if(next)next.disabled=atEnd;
  }
  function go(i){var target=cards[Math.max(0,Math.min(cards.length-1,i))].offsetLeft-2;rail.scrollTo({left:target,behavior:reduced?'auto':'smooth'})}
  if(prev)prev.addEventListener('click',function(){go(index-1)});
  if(next)next.addEventListener('click',function(){go(index+1)});
  eras.forEach(function(btn){btn.addEventListener('click',function(){go(parseInt(btn.getAttribute('data-sp-era'),10))})});
  rail.addEventListener('scroll',function(){if(!ticking){ticking=true;window.requestAnimationFrame(function(){update();ticking=false;})}},{passive:true});
  rail.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();go(index+1)}if(e.key==='ArrowLeft'){e.preventDefault();go(index-1)}});
  rail.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse'||e.button!==0)return;dragging=true;startX=e.clientX;startScroll=rail.scrollLeft;rail.classList.add('is-dragging');rail.setPointerCapture(e.pointerId)});
  rail.addEventListener('pointermove',function(e){if(!dragging)return;rail.scrollLeft=startScroll-(e.clientX-startX)});
  function endDrag(e){if(!dragging)return;dragging=false;rail.classList.remove('is-dragging');if(rail.hasPointerCapture(e.pointerId))rail.releasePointerCapture(e.pointerId)}
  rail.addEventListener('pointerup',endDrag);rail.addEventListener('pointercancel',endDrag);
  window.addEventListener('resize',update,{passive:true});update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-trust"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-values"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();
})();
